import { useIonViewWillLeave } from "@ionic/react";
import { useFormsStore } from "../../../../../Common/store/common";
import { useEffectOnlyOnce } from "../../../../../Common/utils/common";
import LoginOTPInterfaceStore from "../../interface/LoginOTPInterface";

const useDestructor = () => {
  useIonViewWillLeave(() => {
    const { setFormLoading } = useFormsStore.getState();
    setFormLoading(false);
  });

  useEffectOnlyOnce(() => () => {
    const { setFormLoading } = useFormsStore.getState();
    setFormLoading(false);

    const { resetStore } = LoginOTPInterfaceStore.getState();
    resetStore();
  });
};

export default useDestructor;
